import React from 'react';

const CreateGroupModal = ({
  show,
  onClose,
  groupForm,
  onGroupFormChange,
  onSubmit,
  editingGroup,
  groupTypes,
  groupTypeLabels,
  isLoading,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex h-full w-full items-center justify-center overflow-y-auto bg-gray-600 bg-opacity-50">
      <div className="relative mx-auto w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <h3 className="mb-4 text-lg font-medium leading-6 text-gray-900">
          {editingGroup ? 'Edit Training Group' : 'Create New Training Group'}
        </h3>
        <form onSubmit={onSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="group-name" className="block text-sm font-medium text-gray-700">
                Name
              </label>
              <input
                type="text"
                name="name"
                id="group-name"
                value={groupForm.name}
                onChange={onGroupFormChange}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                required
              />
            </div>
            <div>
              <label
                htmlFor="group-description"
                className="block text-sm font-medium text-gray-700"
              >
                Description
              </label>
              <textarea
                name="description"
                id="group-description"
                rows={3}
                value={groupForm.description}
                onChange={onGroupFormChange}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
              />
            </div>
            <div>
              <label htmlFor="group-type" className="block text-sm font-medium text-gray-700">
                Group Type
              </label>
              <select
                name="group_type"
                id="group-type"
                value={groupForm.group_type}
                onChange={onGroupFormChange}
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
              >
                {groupTypes.map((type) => (
                  <option key={type} value={type}>
                    {groupTypeLabels[type]}
                  </option>
                ))}
              </select>
            </div>

            {/* Availability Reminder Settings */}
            <div className="border-t border-gray-200 pt-4">
              <h4 className="mb-3 text-sm font-medium text-gray-900">
                Availability Reminder Settings
              </h4>

              <div className="space-y-3">
                <div className="flex items-center">
                  <input
                    id="group-availability_reminder_enabled"
                    name="availability_reminder_enabled"
                    type="checkbox"
                    checked={groupForm.availability_reminder_enabled !== false}
                    onChange={onGroupFormChange}
                    className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  <label
                    htmlFor="group-availability_reminder_enabled"
                    className="ml-2 block text-sm text-gray-900"
                  >
                    Enable automatic availability reminders
                  </label>
                </div>

                {groupForm.availability_reminder_enabled !== false && (
                  <div>
                    <label
                      htmlFor="group-availability_reminder_day"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Send reminders on
                    </label>
                    <select
                      name="availability_reminder_day"
                      id="group-availability_reminder_day"
                      value={groupForm.availability_reminder_day || 6}
                      onChange={onGroupFormChange}
                      className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                    >
                      <option value={0}>Monday</option>
                      <option value={1}>Tuesday</option>
                      <option value={2}>Wednesday</option>
                      <option value={3}>Thursday</option>
                      <option value={4}>Friday</option>
                      <option value={5}>Saturday</option>
                      <option value={6}>Sunday</option>
                    </select>
                    <p className="mt-1 text-xs text-gray-500">
                      Members will receive automatic reminders to set their availability on this day
                      each week
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-blue-300"
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : editingGroup ? 'Save Changes' : 'Create Group'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateGroupModal;
